export const SET_WORK_DATA = "SET_WORK_DATA";
export const SET_WORK_PAGINATION = "SET_WORK_PAGINATION";
export const SET_WORK_DETAIL_DATA = "SET_WORK_DETAIL_DATA";
export const SET_APPROVAL_HISTORY_DATA = "SET_APPROVAL_HISTORY_DATA";
export const SET_APPROVAL_HISTORY_PAGINATION = "SET_APPROVAL_HISTORY_PAGINATION";
